export default "__VITE_ASSET__AVCoYYwi__"